import React, { useEffect, useState } from "react";
import { Dropdown, Nav, Navbar } from "rsuite";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import * as userManager from '../../Services/UserSessionManager';
import { Link, useNavigate } from "react-router-dom";
import './Home.css';
import { EmployeeInfoModal } from "../EmployeeTeamDetail/EmployeeInfomodal";
import { Modal } from "react-bootstrap";
export  const KRAMenu=()=>{
    const Logout = () => {
        userManager.SetUserToken('');
        sessionStorage.clear();
        window.location.reload();
        
    }
        const [checkRole,setCheckRole]=useState(userManager.GetUserRole());
        const [checkProductionRole,setProductionCheckRole]=useState(userManager.GetUserProductionRole());


    const[loginid,setLoginid]=useState(userManager.GetUserLoginID());
    const[userName,setUserName]=useState(userManager.GetUserName());
    const[popup,setpopUp]=useState(false);
    const handleClose=()=>setpopUp(false);

    const showPopUp=()=>{
        setpopUp(true); 
    }
    return(
       <>
        {checkRole=='H' ||checkRole=='PM' || checkRole=='M'|| checkRole=='BI' || checkRole=='QM'|| checkRole=='A'?
        
        <Dropdown title={"KRA"}
        className="nav-bar-text-white"
        icon={<BootstrapIcon cssClasses="p-2 nav-bar-text-white" bootStrapIconName="card-checklist" size={18} />}>
      <Modal show={popup} fullscreen={true} onHide={handleClose}>
                <EmployeeInfoModal id={loginid} title={userName} />
                </Modal>
                
          
                {checkRole=='M'|| checkRole=='QM'||checkRole=='A'?
                
                <Link className="link-simple" to={'/KraApproval'}>
                    <Dropdown.Item
                        icon={<BootstrapIcon bootStrapIconName={"ui-checks"} size={14} cssClasses={'pe-2'} />}
                    >
                        Productivity Approval
                    </Dropdown.Item>
                </Link>:<></>}
                <Link className="link-simple" to={'/Productivityreport'}>
                 <Dropdown.Item
                     icon={<BootstrapIcon bootStrapIconName={"clipboard-data-fill"} size={14} cssClasses={'pe-2'} />}
                 >
                      Productivity Report
                 </Dropdown.Item>
             </Link>
             <Link className="link-simple" to={'/QualityReport'}>
                   <Dropdown.Item
                       icon={<BootstrapIcon bootStrapIconName={"file-earmark-bar-graph-fill"} size={14} cssClasses={'pe-2'} />}
                   >
                       Quality Report
                   </Dropdown.Item>
                   </Link>
                   <Link className="link-simple" to={'/PKTReport'}>
                   <Dropdown.Item
                       icon={<BootstrapIcon bootStrapIconName={"file-earmark-bar-graph-fill"} size={14} cssClasses={'pe-2'} />}
                   >
                       PKT Report
                   </Dropdown.Item>
                   </Link>
                  
                   {checkRole=='M' ||checkRole=='PM' || checkRole=='QM'||checkRole=='A' ||checkRole=='BI'||checkRole=='H'?
                   
                 <Link className="link-simple" to={'/AttendanceReport'}>
                 <Dropdown.Item
                     icon={<BootstrapIcon bootStrapIconName={"person-check"} size={14} cssClasses={'pe-2'} />}
                 >
                     Attendance Report
                 </Dropdown.Item>
             </Link>
             :<></>}
                {checkRole=='M'||checkRole=='PM'||checkRole=='QM'||checkRole=='A'?
                <div>
               
                <Link className="link-simple" to={'/ManagerFeedback'}>
                    <Dropdown.Item
                        icon={<BootstrapIcon bootStrapIconName={"people-fill"} size={14} cssClasses={'pe-2'} />}
                    >
                        Manager Feedback 
                    </Dropdown.Item>

                </Link>  </div>
                :<></>}
                {checkRole=='M' ||checkRole=='PM' || checkRole=='QM'||checkRole=='A' ||checkRole=='BI'||checkRole=='H'?
                   
                   <Link className="link-simple" to={'/KRAReport'}>
                   <Dropdown.Item
                       icon={<BootstrapIcon bootStrapIconName={"clipboard-data-fill"} size={14} cssClasses={'pe-2'} />}
                   >
                     Overall KRA Report
                   </Dropdown.Item>
               </Link>
               :<></>}

                
                 {checkRole=='QM' || checkRole=='A'?
                 <Link className="link-simple" to={'/QualityUpload'}>
                 <Dropdown.Item
                     icon={<BootstrapIcon bootStrapIconName={"upload"} size={14} cssClasses={'pe-2'} />}
                 >
                      Quality Upload
                 </Dropdown.Item>
                 </Link>:<></>} 
                 {checkRole=='PM' ||checkRole=='A'?
                 <Link className="link-simple" to={'/PKTUpload'}>
                 <Dropdown.Item
                     icon={<BootstrapIcon bootStrapIconName={"upload"} size={14} cssClasses={'pe-2'} />}
                 >
                      PKT Upload
                 </Dropdown.Item>
                 </Link>:<></>} 
            
                
            
                   
                   
             {checkRole=='M' ||checkRole=='PM' || checkRole=='QM'?
              <Link className="link-simple" to={'/WeightageMaster'}>
                    <Dropdown.Item
                        icon={<BootstrapIcon bootStrapIconName={"bank2"} size={14} cssClasses={'pe-2'} />}
                    >
                        KRA Productivity Target Master
                    </Dropdown.Item>
                </Link>:<></>
}
            </Dropdown>
            
           :  
           checkProductionRole!=='Non-Production (Manager)'&& checkProductionRole!=='Non-production (Other)'&&checkProductionRole!=='Non-Production (Lead)'?          
           <Dropdown title={"Me"} 
           className="nav-bar-text-white"
           icon={<BootstrapIcon cssClasses="p-2 nav-bar-text-white" bootStrapIconName="person-circle" size={18} />}>
           <Link className="link-simple" to={'/EntryScreen'}>
           <Dropdown.Item
               icon={<BootstrapIcon bootStrapIconName={"keyboard-fill"} size={14} cssClasses={'pe-2'} />}
           >
              Productivity Entry
           </Dropdown.Item>
       </Link>
       
       </Dropdown> :<></> }
       
       </>
    )
}
